// Centralised, defensive API error formatter.
// FastAPI returns errors as `{detail: string}` for normal HTTPException,
// `{detail: [{msg, loc, type}]}` for Pydantic validation, and sometimes
// non-JSON responses (network, CORS, 502). This helper handles all shapes
// without ever throwing — UI code can safely `toast.error(getErrorMessage(e))`.

export const getErrorMessage = (error, fallback = 'An error occurred') => {
  if (!error) return fallback;
  // Network / no-response errors
  if (!error.response) {
    if (error.message === 'Network Error') return 'Network error — please check your connection.';
    return error.message || fallback;
  }
  const data = error.response.data;
  const detail = data?.detail ?? data?.error ?? data?.message;
  if (!detail) {
    if (error.response.status >= 500) return `Server error (${error.response.status}). Please try again.`;
    return fallback;
  }
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(e => e.msg || e.message || JSON.stringify(e)).join(', ');
  }
  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return fallback;
};

export default getErrorMessage;
